export default {
  state: {
    requestID: null,
    action: '',
    identityNumber: '',
    editableFields: null,
  },
  mutations: {
    SET_REQUEST_ID(state: any, payload: any) {
      state.requestID = payload;
    },
    SET_IDENTITY_NUMBER(state: any, payload: any) {
      state.identityNumber = payload;
    },
    SET_ACTION(state: any, payload: any) {
      state.action = payload;
    },
    SET_EDITABLE_FIELDS(state: any, payload: any) {
      state.editableFields = payload;
    }
  },
}
